export default __webpack_public_path__ + "static/media/exgcoin.ce0e9822.png";